import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService } from 'app/core/app-information.service';
import { BrewersUnitOfWork } from 'app/core/core.module';
import { HistoryService, LoadHistoryFilter } from 'app/core/history.service';
import { LoadService } from 'app/core/load.service';
import { TicketAttachment } from 'app/core/model/entity-model';
import { SessionInformationService } from 'app/core/session-information.service';
import DataSource from 'devextreme/data/data_source';
import { confirm } from 'devextreme/ui/dialog';

@Component({
    standalone: false,
    selector: 'app-load-history',
    templateUrl: './load-history.component.html',
    styleUrl: './load-history.component.scss',
})
export class LoadHistoryComponent implements OnInit {
    router = inject(Router);
    appInfo = inject(AppInformationService);
    historyService = inject(HistoryService);
    sessionInfo = inject(SessionInformationService);
    uow = inject(BrewersUnitOfWork);
    loadService = inject(LoadService);

    customersDS: DataSource;
    productsDS: DataSource;

    filter: LoadHistoryFilter;
    loads: any[];

    async ngOnInit() {
        this.appInfo.pleaseWaitShow();
        const customers = await this.uow.customers.getLookupCustomers();
        this.customersDS = new DataSource({ store: customers, paginate: true });
        const products = await this.uow.getLookupProducts();
        this.productsDS = new DataSource({ store: products, paginate: true });


        this.filter = this.sessionInfo.getItem('load-history-filter') ?? {};
        this.appInfo.pleaseWaitHide();
    }

    async search() {
        const hasSelectedFilter = this.hasSelectedFilter();
        if (!hasSelectedFilter) {
            const result = await confirm('No filters set. Are you sure you want to continue?', this.appInfo.settings.company);
            if (!result) return;
        }

        this.appInfo.pleaseWaitShow();
        const loads = await this.historyService.getLoadHistory(this.filter);
        this.loadService.setAdditivesHtml(loads);
        this.loads = loads;
        this.sessionInfo.setItem('load-history-filter', this.filter);
        this.appInfo.pleaseWaitHide();
    }

    hasSelectedFilter() {
        return this.filter && (this.filter.loadDateStart || this.filter.loadDateEnd || this.filter.customerId || this.filter.productId || this.filter.ticketNumber);
    }

    clear() {
        this.filter = {};
        this.sessionInfo.removeItem('load-history-filter');
        this.loads = null;
    }

    onRowPrepared(e) {
        if (e.rowType !== 'data' || !e.data) return;

        const load = e.data as any;
        if (load.onHold) e.rowElement.className += ' on-hold';
    }

    onCellPrepared(e) {
        if (e.rowType === 'data') {
            if (!e.data.productId) {
                if (e.column.dataField === 'productId') {
                    e.cellElement.className = e.cellElement.className + ' red-cell';
                }
            }
            if (!e.data.customerId) {
                if (e.column.dataField === 'companyName') {
                    e.cellElement.className = e.cellElement.className + ' red-cell';
                }
            }
            if (!e.data.deliveryProductId && e.data.carrier === 'BREWERS') {
                if (e.column.dataField === 'carrier') {
                    e.cellElement.className = e.cellElement.className + ' red-cell';
                }
            }
            if (e.column.dataField === 'price' && !e.data.priceVerified && (e.data.ticketAttachmentTypeId === TicketAttachment.Types.RediMix || !e.data.hasTicketAttachment)) {
                e.cellElement.className = e.cellElement.className + ' price-not-verified';
            }
        }
    }

    openCustomer(customerId?: any) {
        this.router.navigate([`/customers/${customerId ? customerId : 'new'}`]);
    }
}
